import React from 'react';
import ReactDOM from 'react-dom';

export {CartRowService};


class CartRowService extends React.Component{
    constructor(props) {
        super(props);
        this.state = { product: props.product, opened: false };
        this.toggleBox = this.toggleBox.bind(this);
    }

    toggleBox(){
        this.setState({opened: !this.state.opened});
    }

    render() {
        let services_price = 0;
        let quantity = this.props.product.quantity;
        quantity = 1;
        let services = this.props.services;
        this.props.group.additional_services.forEach((service) => {
            if (!service.consumable_products && services.indexOf(service.product_id) !== -1){
                services_price += service.price * quantity;
            }else{
                if (service.consumable_products){
                    service.consumable_products.forEach((service_product) => {
                        if (services.indexOf(service.product_id + ',' + service_product.id) !== -1){
                            services_price += service.price * quantity;
                            services_price += service_product.price * quantity;
                        }
                    });
                }

            }
        });

        return (
            <>
            {this.props.group.groups.length == 0 ? (

            <div className={"accessories__item-info"  + (this.state.opened ? ' accessories__item-info_opened' : '')}>
                <div className="accessories__item-info-header thanks-page__product-row thanks-page__product-row_padding-left">
                    <a className={"link-w-border accessories__item-link thanks-page__product-link_arrow" + (this.state.opened ? ' accessories__item-link_opened' : '')}  onClick={this.toggleBox}>{tools.getLangField(this.props.group,'name')}</a>
                    <If condition={services_price > 0}>
                        <div className="thanks-page__product-service">+{tools.displayPrice(services_price)} ₴</div>
                    </If>
                </div>
                <div className="accessories__item-info-content">
                    {this.props.group.additional_services.map((service) => (
                        <>
                        <If condition={!service.consumable_products}>
                            <div className="accessories__item-info-row" key={"service_" + this.props.product.product_id + '_' + service.product_id}>
                                <div className="form-check pb-0">
                                    <input className="form-check-input"
                                           name={"service_" + this.props.bundle_id + '_' + this.props.product.id + '_' + this.props.group.id}
                                           type={this.props.group.additional_services.length == 1 ? "checkbox" : "radio"}
                                           id={"service_" + this.props.bundle_id + '_' + this.props.product.id + '_' + service.product_id}
                                           value={service.product_id}
                                           checked={this.props.services.indexOf(service.product_id) !== -1}
                                           onChange={() => this.props.handleServiceToggle(service.product_id, this.props.group.id, this.props.product.parent_category_id, this.props.bundle_id)}
                                    />
                                    <label className="form-check-label"
                                           onClick={(e) => {
                                               if(e.target.previousSibling.checked && e.target.previousSibling.type== 'radio'){
                                                   e.preventDefault();
                                                   e.stopPropagation();
                                                   e.target.previousSibling.checked = false;
                                                   this.props.handleServiceToggle(service.product_id, this.props.group.id, this.props.product.parent_category_id, this.props.bundle_id);
                                               }
                                           }}
                                           htmlFor={"service_" + this.props.bundle_id + '_' + this.props.product.id + '_' + service.product_id}>{tools.getLangField(service,'name')}&nbsp;</label>
                                </div>
                                <div className="accessories__item-bonus">+{service.price} ₴</div>
                            </div>
                        </If>
                        <If condition={service.consumable_products && service.consumable_products.length}>
                            {service.consumable_products.sort((a, b) => b.price - a.price).slice(0, 3).map((service_product) => (
                            <div className="accessories__item-info-row" key={"service_" + this.props.product.product_id + '_' + service_product.id}>
                                <div className="form-check pb-0">
                                    <input className="form-check-input"
                                           name={"service_" + this.props.bundle_id + '_' + this.props.product.id + '_' + this.props.group.id}
                                           type={"radio"}
                                           id={"service_" + this.props.bundle_id + '_' + this.props.product.id + '_' + service_product.id}
                                           value={service.product_id + ',' + service_product.id}
                                           checked={this.props.services.indexOf(service.product_id + ',' + service_product.id) !== -1}
                                           onChange={() => this.props.handleServiceToggle(service.product_id + ',' + service_product.id, this.props.group.id, this.props.product.parent_category_id, this.props.bundle_id)}
                                    />
                                    <label className="form-check-label"
                                           onClick={(e) => {
                                               if(e.target.previousSibling.checked && e.target.previousSibling.type== 'radio'){
                                                   e.preventDefault();
                                                   e.stopPropagation();
                                                   e.target.previousSibling.checked = false;
                                                   this.props.handleServiceToggle(service_product.product_id, this.props.group.id, this.props.product.parent_category_id, this.props.bundle_id);
                                               }
                                           }}
                                           htmlFor={"service_" + this.props.bundle_id + '_' + this.props.product.id + '_' + service_product.id}>{tools.getLangField(service_product,'name')}&nbsp;</label>
                                </div>
                                <div className="accessories__item-bonus">+{service_product.price + service.price} ₴</div>
                            </div>
                            ))}
                        </If>
                        </>

                    ))}
                </div>
            </div>
        ) : (
            <>
                {this.props.group.groups.map((group) => (
                    <React.Fragment key={group.id}>
                        <CartRowService
                            group={group}
                            product={this.props.product}
                            services={this.props.services}
                            handleServiceToggle={this.props.handleServiceToggle}
                            position={this.props.position}
                            bundle_id={this.props.bundle_id}
                        />
                    </React.Fragment>
                ))}
            </>

        )}
        </>
        );
    }
}